import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "axios";

const AuthContext = React.createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = Cookies.get("user");

    if (!savedUser) return;

    try {
      setUser(JSON.parse(savedUser));
    } catch (error) {
      console.error("Invalid user cookie:", error);
      Cookies.remove("user");
    }
  }, []);

  const login = async (userData) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND}/api/users/login`,
      userData,
    );

    const loggedInUser = response.data.user;

    setUser(loggedInUser);

    Cookies.set("user", JSON.stringify(loggedInUser), {
      expires: 7,
      secure: process.env.NODE_ENV === "production",
      sameSite: "strict",
    });

    return response.data;
  };

  const logout = () => {
    setUser(null);
    Cookies.remove("user");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
